import React from 'react'
import SideBarBack from '../../components/SidebarBack'
import { useDispatch } from 'react-redux'
import {
    setDrawerActiveMenu,
} from '../../store/features/webUtilitiesSlice'
import activeBill from '../../assets/images/Subscription/activeBill.webp'
import inactiveBill from '../../assets/images/Subscription/inactiveBill.webp'
import right from '../../assets/images/Subscription/right.webp'

const menuOption = [
    {
        year: "2024",
        bills: [
            {
                month: "January",
                plan: "Premium 12 months",
                period: "10th Dec, 2024 to 10 Jan, 2025",
                amount: "100.00",
                isActive: true
            },
        ]
    },
    {
        year: "2023",
        bills: [
            {
                month: "December",
                plan: "Premium 12 months",
                period: "10th Nov, 2024 to 10 Dec, 2025",
                amount: "100.00",
                isActive: false
            },
            {
                month: "Novemeber",
                plan: "Premium 12 months",
                period: "10th Oct, 2024 to 10 Nov, 2025",
                amount: "100.00",
                isActive: false
            },
        ]
    },
]

export default function Menu() {

    const dispatch = useDispatch()
    // const handleChangeSidebar = async menu => {
    //     await dispatch(setDrawerActiveMenu(menu))
    // }

    const handleCloseDrawer = async () => {
        await dispatch(setDrawerActiveMenu(32))
    }

    return (
        <div className='w-full h-full'>
            <div className='w-full flex mb-2'>
                <SideBarBack handleCloseDrawer={handleCloseDrawer} />
            </div>
            <div className='flex flex-col gap-2 mt-2 w-11/12 mx-auto pb-14'>
                <p className='text-2xl font-semibold mb-2 text-center'>Previous bills</p>
                <div className='mt-0'>
                    {menuOption.map((yearItem, yearIndex) => (
                        <div key={yearIndex} className="year-bills-container mt-3">
                            <h2 className="text-lg font-semibold">{yearItem.year}</h2>
                            {yearItem.bills.map((bill, billIndex) => (
                                <div key={billIndex} className={`bill-item flex items-center mt-2 gap-3 ${bill.isActive ? 'active' : 'inactive'}`}>
                                    {bill.isActive ? (
                                        <img src={activeBill} className="h-6" alt="Active Bill" />
                                    ) : (
                                        <img src={inactiveBill} className="h-6" alt="Inactive Bill" />
                                    )}
                                    <div className="bill-content">
                                        <p className="text-sm font-medium">{bill.month}</p>
                                        <p className="text-xs">Plan: {bill.plan}</p>
                                        <p className="text-xs">Period: {bill.period}</p>
                                        <p className="text-xs">Amount: ${bill.amount}</p>
                                    </div>
                                    <img src={right} className="h-7 cursor-pointer" alt="Right Arrow" />
                                </div>
                            ))}
                        </div>
                    ))}
                </div>
            </div>
        </div>
    )
}
